/**
 * Bundle entry point (esbuild --bundle --splitting --format=esm).
 *
 * These are plain side-effect imports - none of the imported files use
 * `export`, they still just declare a global `class X {}` and
 * `window.X = X` exactly as when they were separate <script> tags. ESM
 * can import a non-module script for its side effects without it needing
 * to export anything, so nothing in these files themselves had to change.
 * Order matters here the same way the old <script> tag order did (later
 * files reference earlier ones' globals at construction time via app.js).
 *
 * MoviesPage.js/SeriesPage.js/Settings.js/WatchPage.js are NOT imported
 * here - they're loaded lazily, only on first visit to that page (see
 * window.__lazyPageImports below and app.js's navigateTo()), so a visit
 * that never opens Movies never downloads/parses/executes its code.
 */
import './utils.js';
import './icons.js';
import './api.js';
import './cast.js';
import './components/VideoPlayer.js';
import './components/ChannelList.js';
import './components/SourceManager.js';
import './components/CategoryRail.js';
import './components/EpgGuide.js';
import './pages/HomePage.js';
import './pages/Guide.js';
import './spatialNav.js';
import './app.js';

// esbuild's --splitting turns each of these dynamic imports into its own
// separate output chunk automatically, fetched only when actually called.
window.__lazyPageImports = {
    movies: () => import('./pages/MoviesPage.js'),
    series: () => import('./pages/SeriesPage.js'),
    settings: () => import('./pages/Settings.js'),
    watch: () => import('./pages/WatchPage.js'),
};
